import React, { PureComponent } from 'react';
import { Icon } from 'react-fa';

class Component extends PureComponent {

  render() {
    const { isFetching = false, title, children } = this.props;
    return (
      <div className="layout-section">
        <h2 className="layout-section__title">{title}</h2>
        <div className="layout-section__container">
          {isFetching ? <Icon spin name="spinner"/> : children}
        </div>
      </div>
    );
  }
}

Component.propTypes = {};
Component.defaultProps = {};

export default Component;



// WEBPACK FOOTER //
// ./src/components/layout-section/index.js